import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FanIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.64 19.12C4.14 19.12 3.18 18.04 3.18 16.42C3.18 13.82 5.72 11.26 8.26 11.26C8.78 11.26 9.34 11.36 10.1 11.86L11.6 11C10.02 9.84 9.14 8.02 9.14 6.36C9.14 4.52 10.24 3.16 11.68 3.16C13.96 3.16 15.68 5.56 15.68 8.12C15.68 9.58 15.12 10.84 13.84 11.64V13.32C14.72 12.94 15.34 12.82 16 12.82C18.88 12.82 20.82 14.42 20.82 16.32C20.82 17.86 19.2 19.1 17.18 19.1C14.46 19.1 12.42 17.56 12.14 15L10.4 13.98C10.14 16.82 7.8 19.12 5.64 19.12ZM13.14 10.42C13.72 9.98 14.16 9.12 14.16 7.94C14.16 6.58 13.2 4.7 11.94 4.7C11.08 4.7 10.66 5.58 10.66 6.46C10.66 7.56 11.46 9.44 13.14 10.42ZM9.08 13.2C7.6 12.4 5.74 13.7 5.04 14.98C4.58 15.88 4.52 16.94 5.32 17.42C6.26 17.98 7.78 16.96 8.5 15.62C8.86 14.94 9.1 14.1 9.08 13.2ZM13.76 14.96C13.98 16.82 15.78 17.68 17.22 17.68C18.24 17.68 19.24 17.2 19.24 16.28C19.24 15.04 17.7 14.34 16.18 14.34C15.4 14.34 14.54 14.52 13.76 14.96Z" />
    </SvgIcon>
  );
});
